/* ════════════════════════════════════════════════
   SUGAR DADDY CHOCOLATE CO. — Theme JS
   sd.js · v1.0 · London
   ════════════════════════════════════════════════ */

(function () {
  'use strict';

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Intersection observer for reveals ── */
  const io = new IntersectionObserver(entries => {
    for (const e of entries) {
      if (e.isIntersecting) {
        e.target.classList.add('sd-in');
        io.unobserve(e.target);
      }
    }
  }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll(
    '.sd-era, .sd-dm, .sd-bar-strip, .sd-manifesto, .sd-receipts, ' +
    '.sd-list-cta, .sd-manifesto__list, .sd-footer__mark, .sd-photo-wrap, .f-rise'
  ).forEach(el => io.observe(el));

  /* ── Nav shrink on scroll ── */
  const nav = document.querySelector('.sd-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('sd-nav--shrunk', scrollY > 30);
    }, { passive: true });
  }

  /* ── Hero entrance ── */
  const hero = document.querySelector('.sd-hero');
  if (hero) {
    requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('sd-reveal')));

    if (!reduced) {
      hero.addEventListener('pointermove', e => {
        const r = hero.getBoundingClientRect();
        hero.style.setProperty('--mx', (e.clientX - r.left) / r.width * 100 + '%');
        hero.style.setProperty('--my', (e.clientY - r.top) / r.height * 100 + '%');
      });
      let raf;
      window.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          hero.style.setProperty('--sx', scrollY * .14 + 'px');
          raf = null;
        });
      }, { passive: true });
    }
  }

  /* ── Magnetic buttons ── */
  if (!reduced) {
    document.querySelectorAll('.sd-btn, .sd-pdp__btn').forEach(btn => {
      btn.addEventListener('pointermove', e => {
        const r = btn.getBoundingClientRect();
        btn.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .18}px,${(e.clientY - r.top - r.height / 2) * .18}px) translateY(-3px)`;
      });
      btn.addEventListener('pointerleave', () => { btn.style.transform = ''; });
    });
  }

  /* ── 3D card tilt ── */
  if (!reduced) {
    document.querySelectorAll('.sd-era').forEach(card => {
      card.addEventListener('pointermove', e => {
        const r = card.getBoundingClientRect();
        const rx = (0.5 - (e.clientY - r.top) / r.height) * 5;
        const ry = ((e.clientX - r.left) / r.width - 0.5) * 5;
        card.style.transform = `translateY(-6px) rotateX(${rx}deg) rotateY(${ry}deg)`;
      });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });
  }

  /* ── Toast ── */
  const toast = document.getElementById('sd-toast');
  const toastTxt = document.getElementById('sd-toast-text');
  let toastTimer;

  window.sdShowToast = function (msg, color) {
    if (!toast || !toastTxt) return;
    toastTxt.textContent = msg;
    if (color) toast.style.borderTopColor = color;
    toast.classList.add('sd-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('sd-show'), 3000);
  };

  /* ── Crumb particles ── */
  window.sdCrumbs = function (ox, oy, col) {
    if (reduced) return;
    const cartBtn = document.querySelector('.sd-nav__cart');
    if (!cartBtn) return;
    const tr = cartBtn.getBoundingClientRect();
    const tx = tr.left + tr.width / 2, ty = tr.top + tr.height / 2;
    for (let i = 0; i < 9; i++) {
      const el = document.createElement('div');
      el.className = 'sd-crumb';
      el.style.setProperty('--c', col || '#7AC943');
      const s = 5 + Math.random() * 8;
      el.style.cssText += `width:${s}px;height:${s}px;left:${ox}px;top:${oy}px;`;
      const bx = (Math.random() - .5) * 80, by = -40 - Math.random() * 40, rot = (Math.random() - .5) * 720;
      document.body.appendChild(el);
      el.animate([
        { transform: 'translate(0,0) rotate(0)', opacity: 1 },
        { transform: `translate(${bx}px,${by}px) rotate(${rot / 3}deg)`, opacity: 1, offset: .25 },
        { transform: `translate(${tx - ox}px,${ty - oy}px) rotate(${rot}deg)`, opacity: 0 }
      ], { duration: 700 + Math.random() * 200, easing: 'cubic-bezier(.5,0,.6,1)', fill: 'forwards' })
        .onfinish = () => el.remove();
    }
  };

  /* ── Cart badge bump ── */
  window.sdBumpCart = function () {
    const cartEl = document.querySelector('.sd-nav__cart');
    if (!cartEl) return;
    cartEl.classList.remove('sd-bumped');
    void cartEl.offsetWidth;
    cartEl.classList.add('sd-bumped');
  };

  /* ── Update cart badge count ── */
  window.sdUpdateCartCount = function () {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badge = document.querySelector('.sd-nav__cart-badge');
        if (badge) badge.textContent = cart.item_count;
      })
      .catch(() => {});
  };

  /* ── Add to Cart (Shopify AJAX API) ── */
  window.sdAddToCart = function (variantId, quantity, onSuccess, onError) {
    quantity = quantity || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity })
    })
      .then(r => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(item => {
        sdUpdateCartCount();
        sdBumpCart();
        if (typeof onSuccess === 'function') onSuccess(item);
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (typeof onError === 'function') onError(err);
      });
  };

  /* ── Roster add buttons ── */
  document.querySelectorAll('.sd-era__add').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      const isSold = btn.classList.contains('sd-era__add--sold');
      const variantId = btn.dataset.variantId;
      const name = btn.dataset.name || 'Bar';
      const color = btn.dataset.color || '#7AC943';
      const card = btn.closest('.sd-era');

      if (card) { card.classList.remove('snapped'); void card.offsetWidth; card.classList.add('snapped'); }

      const r = btn.getBoundingClientRect();
      sdCrumbs(r.left + r.width / 2, r.top + r.height / 2, color);

      if (isSold) {
        sdShowToast('Added to restock list. You\'ll hear from us.', '#E4002B');
        return;
      }

      if (variantId) {
        sdAddToCart(variantId, 1,
          () => sdShowToast(`Added · 1× ${name}. No talking stage required.`),
          () => sdShowToast('Something went wrong. Try again.')
        );
      } else {
        /* fallback for demo without live Shopify */
        sdBumpCart();
        sdShowToast(`Added · 1× ${name}. No talking stage required.`);
      }
    });
  });

  /* ── PDP add to cart ── */
  const pdpBtn = document.getElementById('sd-pdp-add');
  if (pdpBtn) {
    pdpBtn.addEventListener('click', () => {
      const variantId = pdpBtn.dataset.variantId;
      const name = pdpBtn.dataset.name || 'Bar';
      const wc = document.querySelector('.sd-wrapper-card');

      if (wc) { wc.classList.remove('snapped'); void wc.offsetWidth; wc.classList.add('snapped'); }
      sdCrumbs(
        pdpBtn.getBoundingClientRect().left + pdpBtn.getBoundingClientRect().width / 2,
        pdpBtn.getBoundingClientRect().top + pdpBtn.getBoundingClientRect().height / 2,
        getComputedStyle(document.documentElement).getPropertyValue('--accent').trim() || '#7AC943'
      );

      if (variantId) {
        sdAddToCart(variantId, 1,
          () => sdShowToast(`Added · 1× ${name}. No talking stage required.`),
          () => sdShowToast('Something went wrong. Try again.')
        );
      } else {
        sdBumpCart();
        sdShowToast(`Added · 1× ${name}. No talking stage required.`);
      }
    });
  }

  /* ── Newsletter form ── */
  document.querySelectorAll('.sd-list-form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const msg = form.parentElement.querySelector('.sd-list-success');
      if (msg) msg.textContent = "You're on the list. First in line. Like you deserve.";
      form.reset();
      /* Wire to Klaviyo / Shopify Email here:
         POST to '/contact#contact_form' with FormData, or use Klaviyo subscribe API */
    });
  });

  /* ── Wrapper card entrance (PDP) ── */
  const wc = document.querySelector('.sd-wrapper-card');
  if (wc) {
    const stockFill = document.querySelector('.sd-pdp__stock-fill');
    const stockPct = wc.dataset.stock || '70';
    requestAnimationFrame(() => requestAnimationFrame(() => {
      wc.classList.add('loaded');
      if (stockFill) setTimeout(() => { stockFill.style.width = stockPct + '%'; }, 400);
    }));
  }

  /* ── Cart page quantity controls ── */
  document.querySelectorAll('.sd-qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      const delta = btn.dataset.delta === '-1' ? -1 : 1;
      const qtyEl = btn.parentElement.querySelector('.sd-qty-num');
      const currentQty = parseInt(qtyEl?.textContent || '1');
      const newQty = Math.max(0, currentQty + delta);

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [key]: newQty } })
      })
        .then(r => r.json())
        .then(() => { location.reload(); })
        .catch(() => location.reload());
    });
  });

  /* ── Cart item remove ── */
  document.querySelectorAll('.sd-item-remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [key]: 0 } })
      })
        .then(r => r.json())
        .then(() => location.reload())
        .catch(() => location.reload());
    });
  });

  /* ── Init cart count on load ── */
  sdUpdateCartCount();

})();
